import { Option } from '@sapphire/result';
import {
  ChildSurveyFilter,
  ChildSurveysOptions,
  ChildSurveysRequest,
  ALL_SURVEY_STATUS,
  Survey,
  SurveyKind,
} from '@ps/survey-utils';

export const EVERY_STATUS_OPTIONS: ChildSurveysOptions = {
  statuses: ALL_SURVEY_STATUS,
};

export function childSurveysRequest(
  survey: Survey,
): Option<ChildSurveysRequest> {
  return SurveyKind.childFilter(survey).map((filter) => ({
    filter,
    options: { ...EVERY_STATUS_OPTIONS, targeting: 1 },
  }));
}

export function childFilterOrProjectId(survey: Survey): ChildSurveyFilter {
  return SurveyKind.childFilter(survey).unwrapOr({ projectId: survey.id });
}

export function redirectsWhenChildless(survey: Survey): boolean {
  return SurveyKind.isTraditionalMc(survey);
}
